import { Theme } from '@/types/theme';

export const mobileRoutes = {
  accountProfileMovieClubPayment: '/account/profile/movie-club-payment/mobile',
  accountProfileSavedPayment: '/account/profile/saved-payment/mobile',
};

export const mobileActionRoutes = {
  accountProfileMovieClubPaymentStopped: '/subscriptions/mobile/actionstopped',
  accountProfileMovieClubPaymentSuccess: '/subscriptions/mobile/actioncomplete',
  accountProfileSavedPaymentStopped: '/paymentmethod/mobile/actionstopped',
  accountProfileSavedPaymentSuccess: '/paymentmethod/mobile/actioncomplete',
  refreshAccessToken: '/refresh.aspx',
};

const isValidTheme = (theme: string | null | undefined): theme is Theme => {
  return theme === 'light' || theme === 'dark';
};

export const themeUtils = {
  getThemeFromParams: (searchParams: URLSearchParams | { theme?: string; }): Theme | undefined => {
    const theme = searchParams instanceof URLSearchParams
      ? searchParams.get('theme')
      : searchParams.theme;
    return isValidTheme(theme) ? theme : undefined;
  },
};

export const isMobileUtils = {
  checkIsMobileByPathname: (pathname: string): boolean => {
    return pathname === '/mobile' || pathname.endsWith('/mobile');
  },
  checkIsMobileByUserAgent: (userAgent: string): boolean => {
    if (!userAgent) return false;

    if (userAgent.toLowerCase().includes('cnkapp')) {
      return true;
    } else if ((userAgent.includes('iPhone') || userAgent.includes('iPod') || userAgent.includes('iPad')) &&
        !userAgent.includes('Safari')) {
      return true;
    } else if (userAgent.includes('Android') && userAgent.includes('wv')) {
      return true;
    }

    return false;
  },
  getRoute: (pathname: string, isMobile: boolean): string => {
    if (!isMobile) return pathname;

    const path = pathname === '/' ? '' : pathname;

    return `${path}/mobile`;
  },
};
